import type { HTMLAttributes } from 'react';

import { cn } from '../../lib';
import { Button } from '../ui/button';

type SuggestionsProps = HTMLAttributes<HTMLDivElement>;

export const Suggestions = ({ className, children, ...props }: SuggestionsProps) => (
  <div className={cn('flex flex-wrap gap-2', className)} {...props}>
    {children}
  </div>
);

type SuggestionProps = Omit<React.ComponentProps<typeof Button>, 'onClick' | 'children'> & {
  suggestion: string;
  onClick?: (suggestion: string) => void;
};

export const Suggestion = ({ suggestion, onClick, className, ...props }: SuggestionProps) => (
  <Button
    variant="outline"
    size="sm"
    className={cn('h-auto whitespace-normal text-left py-2 px-3 text-xs', className)}
    onClick={() => onClick?.(suggestion)}
    type="button"
    {...props}
  >
    {suggestion}
  </Button>
);
